import React from "react";
import "../pages/Home.css";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div id="container">
      {/* ===== Header ===== */}
      <header className="header">
        {/* Left Logo */}
        <div className="logo">
          <img
            src={`${process.env.PUBLIC_URL}/images/sj1.jpg`}
            alt="Grampanchayat Logo"
          />
        </div>

        {/* Center Title + ISO */}
        <div className="header-title">
          <h1>गट ग्रामपंचायत सावंगी-घोगली</h1>
          <h2>पंचायत समिती कळमेश्वर, जिल्हा परिषद नागपूर</h2>
          <h3>महाराष्ट्रातील एकमेव ISO प्रमाणित ग्रामपंचायत उपक्रम</h3>

          <div className="iso-section">
            <img
              src={`${process.env.PUBLIC_URL}/images/iso.png`}
              alt="ISO Certified"
            />
            <span>ISO Certified Organization</span>
          </div>
        </div>

        {/* Right Side Saints Photos */}
        <div className="saints-photos">
          <img src={`${process.env.PUBLIC_URL}/images/raje.jpeg`} alt="शिवाजी महाराज" />
          <img src={`${process.env.PUBLIC_URL}/images/Gadgemaharaj.jpg`} alt="गाडगे महाराज" />
          <img src={`${process.env.PUBLIC_URL}/images/tukdojimaharaj.jpg`} alt="तुकोजी महाराज" />
          <img src={`${process.env.PUBLIC_URL}/images/ambedkar.jpg`} alt="DR.br" />
        </div>
      </header>

      <div className="marquee-box">
        <div className="marquee-text">
          गट ग्रामपंचायत सावंगी-घोगली – तालुका कळमेश्वर – जिल्हा नागपूर
        </div>
      </div>



      {/* ===== Main Menu ===== */}
      <nav className="menuicons main-menu">
        <ul>
          <li><Link to="/aboutus">About Us</Link></li>
          <li><Link to="/">मुखपृष्ठ</Link></li>
          <li><Link to="/gramsevakpage">ग्रामपंचायत अधिकारी</Link></li>
          <li><Link to="/sarpanch">सरपंच कार्यकाल</Link></li>
          <li><Link to="/upsarpanch">उपसरपंच कार्यकाल</Link></li>
          <li><Link to="/vikas">विकास कामे</Link></li>
          <li><Link to="/team">सदस्य/कर्मचारी</Link></li>
        </ul>
      </nav>

      {/* ===== Sub Menu ===== */}
      <nav className="menuicons sub-menu">
        <ul>
          <li><Link to="/janmdakhala">जन्म दाखला</Link></li>
          <li><Link to="/death">मृत्यू दाखला</Link></li>
          <li><Link to="/vivah">विवाह दाखला</Link></li>
          <li><Link to="/gallery">Gallery</Link></li>
          <li><Link to="/sabha">सभेची माहिती</Link></li>
          <li><Link to="/contact">संपर्क करा</Link></li>
          <li><Link to="/sadasya">सदस्य कार्यकारणी</Link></li>
        </ul>
      </nav>

      {/* ===== Auto Image Slider (आता खरोखर एकावेळी एक फोटो) ===== */}
      <div className="auto-slider">
        <div className="auto-slider-inner">
          <img src={`${process.env.PUBLIC_URL}/images/slide1.jpg`} alt="Slide 1" />
          <img src={`${process.env.PUBLIC_URL}/images/slide2.jpg`} alt="Slide 2" />
          <img src={`${process.env.PUBLIC_URL}/images/slide3.jpg`} alt="Slide 3" />
          <img src={`${process.env.PUBLIC_URL}/images/slide4.jpg`} alt="Slide 4" />
        </div>
      </div>

      {/* ===== Main Section - Team Table ===== */}
      <main>
        <h3 className="style2">कार्यकारी मंडळ गट ग्रामपंचायत सावंगी-घोगली</h3>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नाव</th>
                <th>पद</th>
                <th>फोन नं.</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["1", "सौ नीता संजय तभाने", "सरपंच", "9822613081"],
                ["2", "श्री.प्रज्वलजी मेघराज तागडे", "उपसरपंच", "9209105220"],
                ["3", "श्री इंद्रकुमार  पारनु तागडे", "सदस्य", "8766435009"],
                ["4", " श्री मुकेश सुरेशजी मरडवार", "सदस्य", "9689344917"],
                ["5", "श्री प्रशांत  देवराज जी शेटे", "सदस्य", "9764120461"],
                ["6", "सौ रंजनाताई शामूजी चोखाद्रे", "सदस्य", "8766435009"],
                ["7", " सौ कुमुदताई रविंद्र बागडे", "सदस्य", "9673191716"],
                ["8", "सौ मीनाताई मधुकरजी धरममाळी", "सदस्य", "9372699398"],
                ["9", "सौ शुभांगी लालाजी धरममाळी", "सदस्य", "9623807062"],
                ["10", "श्री संजय तभाने", "सामाजिक कार्यकर्ता", "--"],
                ["11", "सौ मायाबाई वामन कडू", "अंगणवाडी सेविका", "--"],
                ["12", "सौ पुनमबाई हेमंत धरममाळी", "CRP बचत गट", "--"],
                ["13", "श्री लतिश मनोहर भोतमांगे", "नरेगा मजूर", "--"],
                ["14", "सौ कालिंदी जिचकार", "मुख्याधापक जी. प. शाला", "9272749224"],
              ].map((row, index) => (
                <tr key={index} className={index % 2 === 0 ? "even-row" : ""}>
                  {row.map((cell, i) => (
                    <td key={i}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      {/* ===== Footer ===== */}
      <footer className="footer-section">
        <ul className="social-icons">
          <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/Facebook_logo_(square).png`} alt="Facebook" /></a></li>
          <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/Logo_of_Twitter.png`} alt="Twitter" /></a></li>
          <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/instagaram.webp`} alt="Instagram" /></a></li>
          <li><a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/youtube.png`} alt="YouTube" /></a></li>
        </ul>

        <p className="footer-links">
          <Link to="/copyright">Copyright Policy</Link> | <Link to="/disclaimer">Disclaimer</Link> | <Link to="/privacy">Privacy Policy</Link> | <Link to="/contact">Contact Us</Link>
        </p>

        <p>
          Website Designed, Developed & Maintained by <b>Web-Solution India Pvt. Ltd.</b><br />
          Content provided by Grampanchayat Office, Government of Maharashtra.
        </p>

        <p>© 2025 Web-Solution India Pvt. Ltd.</p>

        <div className="footer-logos">
          <a href="https://swachhbharatmission.ddws.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/swachh-bharat.png`} alt="Swachh Bharat" /></a>
          <a href="https://digitalindia.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/digital-india-logo.png`} alt="Digital India" /></a>
          <a href="https://data.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/data-gov-logo.png`} alt="Data Portal" /></a>
          <a href="https://india.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/portal.jpg`} alt="National Portal" /></a>
          <a href="https://mygov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/mygov.png`} alt="MyGov" /></a>
          <a href="https://meity.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/Meity_logo.png`} alt="MeitY" /></a>
          <a href="https://pmindia.gov.in" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/pm-india-logo.jpg`} alt="PM India" /></a>
        </div>
      </footer>
    </div>
  );
};

export default Home;